<template>
  <div>
    <div class="user-info-table-core mx-2">

      <CRow class="data-table">

        <CCol class="mr-3">
          <CRow lg="6">
            <CCol
              class="t-title"
              lg="4"
            >カードID</CCol>
            <CCol>
              {{ user.cardId }}
            </CCol>
          </CRow>
        </CCol>

        <CCol class="mr-3">
          <CRow lg="6">
            <CCol
              class="t-title"
              lg="4"
            >氏名(カナ)</CCol>
            <CCol>{{ userDisplayName }}</CCol>
          </CRow>
        </CCol>

        <CCol class="mr-3">
          <CRow lg="6">
            <CCol
              class="t-title"
              lg="4"
            >ステータス</CCol>
            <CCol>
              {{ user.status | MemberStatus }}
            </CCol>
          </CRow>
        </CCol>

      </CRow>
    </div>

    <!-- #region Alert -->
    <CAlert
      color="danger"
      class="mt-3 text-center"
      v-if="notFound"
    >
      会員情報がありません。
    </CAlert>
    <!-- #endregion Alert -->

    <!-- #region Modal -->
    <!-- #endregion Modal -->

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "MemberInfo",

  props: {},

  data() {
    return {

      //#region Flag

      loading: false,

      //#endregion Flag

      //#region Response data

      user: {}

      //#endregion Response data

    }
  },

  computed: {

    /** 一覧表表示できるか？ */
    canShowTable() {
      return !this.loading;
    },

    /** ユーザーUUIDがあるか？ */
    hasUuid() {
      console.log(this.uuid);
      return !this.uuid !== "";
    },

    /** ユーザーUUID */
    uuid() {
      return this.$route.params.uuid;
    },

    /** ログインユーザーのロール */
    loginUserRoles() {
      return this.$keycloak.realmAccess.roles;
    },

    /** 許可されているか */
    isAllowed() {
      if (!this.hasUuid) return false;
      if (this.loginUserRoles.includes('liberty_operator_admin')) return true;
      if (this.loginUserRoles.includes('liberty_operator')) return true;
      return false;
    },

    /** 会員表示用名称 */
    userDisplayName() {
      return `${this.user.familyName} ${this.user.givenName}(${this.user.lastName} ${this.user.firstName})`;
    }

  },

  methods: {

    //#region Event
    //#endregion Event


    //#region Request

    /** 会員情報取得 */
    getUser() {
      if (!this.isAllowed) return;

      const uuid = this.uuid;
      const url = `/rest/users/uuid/${uuid}`;

      axios
        .get(url, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          const data = resp.data;
          console.log(data);
          this.user = data;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.PassError = err.response.status;
          this.loading = false;
        });
    },

    //#endregion Request

    //#region Method
    //#endregion Method

  },

  beforeMount() {
    this.getUser();
  },

};
</script>
